<template>
    <div class="floating-back-button" @click="handleClick">
        <img src="@/assets/images/icons/arrow-back.svg" alt="" />
    </div>
</template>

<script lang="ts" setup>
    import { useRouter } from "vue-router";

    const props = defineProps<{
        onBack?: () => void;
    }>();

    const router = useRouter();

    const handleClick = () => {
        if (props.onBack) {
            props.onBack();
        } else {
            router.back();
        }
    };
</script>

<style lang="scss" scoped>
    .floating-back-button {
        position: fixed;
        top: calc(var(--ion-safe-area-top, 0px) + 16px);
        left: 16px;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--color-black-alpha-10);
        border-radius: vw(20px);
        width: vw(40px);
        height: vw(40px);
        background: var(--color-white-alpha-80);
        cursor: pointer;
        transition: border 0.2s ease-out;
        backdrop-filter: blur(8px);

        &:hover {
            border: 1px solid var(--color-black-alpha-15);

            img {
                transform: translateX(-2px);
            }
        }

        img {
            transition: transform 0.2s ease-out;
        }
    }
</style>

<style lang="scss">
    html.dark .floating-back-button img {
        filter: invert(1);
    }
</style>
